import { createSelector } from 'reselect'
import getLoyaltyLoungePassItemViews from '../view/itemViews/getLoyaltyLoungePassItemViews'
import { sum } from 'lib/array/arrayUtils'

const getLoyaltyLoungePassTotals = createSelector(
  (state: App.State) => getLoyaltyLoungePassItemViews(state),
  (view): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    return {
      hasRequiredData: view.hasRequiredData,
      data: {
        price: sum(view.data, itemView => itemView.totals.price),
        memberPrice: 0,
        value: sum(view.data, itemView => itemView.totals.value ?? 0),
        memberValue: 0,
        surcharge: 0,
        extraGuestSurcharge: 0,
        taxesAndFees: sum(view.data, itemView => itemView.totals.taxesAndFees),
      },
    }
  },
)

export default getLoyaltyLoungePassTotals
